import React from "react";
import { motion } from "framer-motion";
import DurationDropdown from "../form/DurationDropdown";
import { usePermission } from "./common/PermissionGuard";

interface HeaderSectionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText: string;
  buttonIcon: React.ReactNode;
  onButtonClick: () => void;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  icon,
  title,
  description,
  buttonText,
  buttonIcon,
  onButtonClick,
}) => {
  // Map title to correct module name for permissions
  const getModuleName = (title: string): string => {
    const titleLower = title.toLowerCase();
    // Handle special cases
    if (titleLower.includes('site')) return 'sites';
    if (titleLower.includes('customer')) return 'customers';
    if (titleLower.includes('order')) return 'orders';
    if (titleLower.includes('contact')) return 'contacts';
    return titleLower;
  };
  
  const canWrite = usePermission(getModuleName(title), "create");
  console.log("has written permission", canWrite);

  return (
    <div className="flex justify-between items-center mb-6 -mt-6">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="flex items-center space-x-3">
          {
            icon && (
              <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
                {icon}
              </div>
            )
          }
          <div>              
            {title && (
              <h3 className="text-heading-3 text-secondary-900 dark:text-white">
                {title}
              </h3>
            )}
            {description && (
              <p className="text-body text-secondary-600 dark:text-secondary-400 mt-1">
                {description}
              </p>
            )}
          </div>
        </div>
      </motion.div>

      {/* <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
      >

        <button
          onClick={onButtonClick}
          className="inline-flex items-center mx-4 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-secondary-800 transition-colors"
        >
          {buttonIcon}
          {buttonText}
        </button>
      </motion.div> */}
      {canWrite && buttonText && onButtonClick && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
        >
          <button
            onClick={onButtonClick}
            className="inline-flex items-center mx-4 px-4 py-2 border border-blue-600 shadow-sm text-sm font-medium rounded-md text-blue-600 bg-transparent hover:bg-blue-50 dark:hover:bg-blue-900/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-secondary-800 transition-colors"
          >
            {buttonIcon}
            {buttonText}
          </button>
        </motion.div>
      )}
    </div>
  );
};

export default HeaderSection;

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import {
//   TextField,
//   MenuItem,
//   InputAdornment,
// } from "@mui/material";
// import { ClockIcon } from "@heroicons/react/24/outline";

// interface HeaderSectionProps {
//   icon: React.ReactNode;
//   title: string;
//   description: string;
//   buttonText: string;
//   buttonIcon: React.ReactNode;
//   onButtonClick: () => void;
// }

// const HeaderSection: React.FC<HeaderSectionProps> = ({
//   icon,
//   title,
//   description,
//   buttonText,
//   buttonIcon,
//   onButtonClick,
// }) => {
//   const [duration, setDuration] = useState("");

//   const durationOptions = [
//     { label: "30 min", value: "30m" },
//     { label: "1 hour", value: "1h" },
//     { label: "2 hours", value: "2h" },
//   ];

//   return (
//     <div className="flex justify-between items-center mb-8">
//       <motion.div
//         initial={{ opacity: 0, x: -20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.3 }}
//       >
//         <div className="flex items-center space-x-3">
//           <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
//             {icon}
//           </div>
//           <div>
//             <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">
//               {title}
//             </h1>
//             <p className="text-secondary-600 dark:text-secondary-400 mt-1">
//               {description}
//             </p>
//           </div>
//         </div>
//       </motion.div>

//       <motion.div
//         initial={{ opacity: 0, x: 20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.3 }}
//         className="flex items-center space-x-4"
//       >
//         <TextField
//           select
//           size="small"
//           name="duration"
//           value={duration}
//           onChange={(e) => setDuration(e.target.value)}
//           placeholder="Select duration"
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <ClockIcon className="h-5 w-5 text-gray-500" />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             bgcolor: "background.paper",
//             borderRadius: 1,
//             minWidth: 150,
//           }}
//         >
//           {durationOptions.map((option) => (
//             <MenuItem key={option.value} value={option.value}>
//               {option.label}
//             </MenuItem>
//           ))}
//         </TextField>

//         <button
//           onClick={onButtonClick}
//           className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-secondary-800 transition-colors"
//         >
//           {buttonIcon}
//           {buttonText}
//         </button>
//       </motion.div>
//     </div>
//   );
// };

// export default HeaderSection;

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import {
//   TextField,
//   MenuItem,
//   InputAdornment,
// } from "@mui/material";
// import { ClockIcon } from "@heroicons/react/24/outline";

// interface HeaderSectionProps {
//   icon: React.ReactNode;
//   title: string;
//   description: string;
//   buttonText: string;
//   buttonIcon: React.ReactNode;
//   onButtonClick: () => void;
//   showDurationDropdown?: boolean; // 🔥 optional toggle
// }

// const HeaderSection: React.FC<HeaderSectionProps> = ({
//   icon,
//   title,
//   description,
//   buttonText,
//   buttonIcon,
//   onButtonClick,
//   showDurationDropdown = false, // default is false
// }) => {
//   const [duration, setDuration] = useState("");

//   const durationOptions = [
//     { label: "Today", value: "today" },
//     { label: "Yesterday", value: "yesterday" },
//     { label: "This Week", value: "this Week" },
//     { label: "Last Week", value: "last Week" },
//     { label: "This Month", value: "this Month" },
//     { label: "Last Month", value: "last Month" },
//     { label: "This Year", value: "this Year" },
//     { label: "Last Year", value: "last Year" },
//   ];

//   return (
//     <div className="flex justify-between items-center mb-8">
//       <motion.div
//         initial={{ opacity: 0, x: -20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.3 }}
//       >
//         <div className="flex items-center space-x-3">
//           <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
//             {icon}
//           </div>
//           <div>
//             <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">
//               {title}
//             </h1>
//             <p className="text-secondary-600 dark:text-secondary-400 mt-1">
//               {description}
//             </p>
//           </div>
//         </div>
//       </motion.div>

//       <motion.div
//         className="flex items-center"
//         initial={{ opacity: 0, x: 20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.3 }}
//       >
//         {showDurationDropdown && (
//           <TextField
//             select
//             value={duration}
//             onChange={(e) => setDuration(e.target.value)}
//             variant="outlined"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <ClockIcon className="h-5 w-5 text-gray-500" />
//                 </InputAdornment>
//               ),
//             }}
//             // className="mx-2 text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 rounded-md shadow-sm transition-colors"
//             size="small"
//           >
//             {durationOptions.map((option) => (
//               <MenuItem key={option.value} value={option.value}>
//                 {option.label}
//               </MenuItem>
//             ))}
//           </TextField>
//         )}

//         <button
//           onClick={onButtonClick}
//           className="inline-flex items-center mx-2 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-secondary-800 transition-colors"
//         >
//           {buttonIcon}
//           {buttonText}
//         </button>
//       </motion.div>
//     </div>
//   );
// };

// export default HeaderSection;
